export default "__VITE_ASSET__4f5c9cd2__"